import Table from "./TableComponent";

export default Table;
